import React from "react"

import { noop } from "shared/lib/noop"
import { UserInfo } from "shared/types/UserInfo"

export interface AuthContextType {
  userInfo: UserInfo | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (redirectLocation?: string) => void
  logout: () => void
}

export const AuthContext = React.createContext<AuthContextType>({
  userInfo: null,
  isAuthenticated: false,
  isLoading: false,
  login: noop,
  logout: noop
})
